// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__2NMK2","header":"PatientBlock_header__3xq5Q","label":"PatientBlock_label__3kkWI","option":"PatientBlock_option__3MaA-"};